export class ApiError extends Error {
    status;
    code;
    body;
    constructor(status, code, body) {
        super(`${code} (${status})`);
        this.status = status;
        this.code = code;
        this.body = body;
    }
}
